import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

interface ImagePreviewModalProps {
  visible: boolean;
  imageUrl: string | null;
  onHide: () => void;
}

const ImagePreviewModal: React.FC<ImagePreviewModalProps> = ({ 
  visible, 
  imageUrl, 
  onHide
}) => {
  if (!imageUrl) return null;

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      style={{ width: '90vw', maxWidth: '1000px' }}
      modal
      showHeader={false}
      className="image-preview-modal"
    >
      <div className="relative">
        {/* Close button */}
        <Button
          icon="pi pi-times"
          className="absolute top-2 right-2 z-2"
          rounded
          severity="secondary"
          onClick={onHide}
        />

        {/* Image */}
        <div className="text-center">
          <img
            src={imageUrl}
            alt="Product image"
            style={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default ImagePreviewModal;